import { Business } from '../models/business.model';
import { AirportService } from '../../airport/airport.service';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
var FeesSectionComponent = /** @class */ (function () {
    function FeesSectionComponent(_toggleService) {
        var _this = this;
        this._toggleService = _toggleService;
        this._toggleService.toggleEmitter.subscribe(function (isOn) {
            _this.isEditModeSet = isOn;
        });
    }
    Object.defineProperty(FeesSectionComponent.prototype, "hasContent", {
        get: function () {
            return AirportService.shouldShowFees(this.business);
        },
        enumerable: true,
        configurable: true
    });
    return FeesSectionComponent;
}());
export { FeesSectionComponent };
